import {CELLS} from '../constants';

import type {RangesItemDto, ValueAcc} from '../typedef';

const getCell = (value = '') => ({value, isValid: true});

export const getFieldValue = (params?: RangesItemDto): ValueAcc => {
    const start = params?.start || '';
    const end = params?.end || '';
    const [SA, SB, SC, SD] = start.split('.');
    const [EA, EB, EC, ED] = end.split('.');

    return {
        [CELLS.START_A]: getCell(SA),
        [CELLS.START_B]: getCell(SB),
        [CELLS.START_C]: getCell(SC),
        [CELLS.START_D]: getCell(SD),
        [CELLS.END_A]: getCell(EA),
        [CELLS.END_B]: getCell(EB),
        [CELLS.END_C]: getCell(EC),
        [CELLS.END_D]: getCell(ED),
    };
};
